import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../services/analytics';

// Hook to track page views automatically
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    analytics.trackPageView(location.pathname);
  }, [location.pathname]);
}

// Hook to get analytics functions
export function useAnalytics() {
  return analytics;
}

// Hook to track component visibility
export function useTrackVisibility(
  elementId: string,
  eventName: string,
  eventParams?: Record<string, any>
) {
  useEffect(() => {
    const element = document.getElementById(elementId);
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            analytics.trackEvent(eventName, eventParams);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [elementId, eventName, eventParams]);
}

// Hook to track time spent on page
export function useTimeOnPage(pageName: string) {
  useEffect(() => {
    const startTime = Date.now();

    return () => {
      const timeSpent = Date.now() - startTime;
      analytics.trackTiming('engagement', 'time_on_page', timeSpent, pageName);
    };
  }, [pageName]);
}